import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoHeader } from '@/components/SeoHeader';
import { Layout } from '@/components/layout';
import { getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { Text, Headline } from '@/components/typography';
import React from 'react';
import { Faq } from '@/sections/career/Faq';
import { MoreInfo } from '@/sections/career/MoreInfo';
import { Career as CareerSection } from '@/sections/careerList/Career';
import { Contact } from '@/sections/careerList/Contact';
import { Job } from '@/types/job';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { getJobs } from '@/sections/jobs/functions/getJobs';
interface Props {
  jobs: Job[];
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function CareerJobsList(t0) {
  const $ = _c(33);
  const {
    jobs,
    menuPromoBanners
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["career", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  usePageView("career-jobs-list");
  let t2;
  if ($[1] !== t) {
    t2 = t("seoList.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seoList.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bgCircle absolute top-0 right-0 z-10 h-[55.25rem] w-[55.25rem] translate-x-1/2 -translate-y-1/3 -rotate-90 lg:translate-x-1/4" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("jobVacancy.title");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Headline as="h1" id="job-vacancy" variant="h1" className="4xl:mb-8 mb-6">{t6}</Headline>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("jobVacancy.text");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Text variant="p1" className="text-gray-800">{t8}</Text>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <div className="z-10 bg-blue-100 pt-[8rem] lg:pt-[16rem]"><div className="px-4"><div className="text-center">{t7}{t9}</div></div></div>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== jobs) {
    t11 = <div className="relative bg-blue-100 pt-14 pb-20 lg:pt-26 lg:pb-40"><CareerSection jobs={jobs} /></div>;
    $[20] = jobs;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div className="relative overflow-hidden">{t5}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SectionDelimiter color="bg-blue-700" background="bg-blue-100" />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="relative bg-blue-700 pt-10 pb-20 lg:pt-20 lg:pb-40" id="contact"><div className="bgCircle absolute top-1/3 right-0 -translate-x-1/2 -translate-y-1/2 lg:top-1/4" /><Contact /></div>;
    t15 = <SectionDelimiter color="bg-blue-50" background="bg-blue-700" />;
    $[26] = t14;
    $[27] = t15;
  } else {
    t14 = $[26];
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="relative overflow-hidden bg-blue-50 pt-10 pb-14 lg:pt-20 lg:pb-26"><div className="relative z-10 flex flex-col gap-20 lg:gap-40"><Faq /><MoreInfo /></div><div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" /></div>;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== menuPromoBanners || $[30] !== t12 || $[31] !== t4) {
    t17 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t12}{t13}{t14}{t15}{t16}</Layout>;
    $[29] = menuPromoBanners;
    $[30] = t12;
    $[31] = t4;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}
export const getStaticProps = (async ctx => {
  const intlProps = await getIntlProps(ctx, ['core', 'career']);
  const {
    jobs
  } = await getJobs();
  return {
    props: {
      jobs,
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...intlProps
    }
  };
}) satisfies GetStaticProps<Props>;